import { createRouter, createWebHistory } from "vue-router"
import Search from "./components/Search.vue"
import DetailItem from "./components/DetailItem.vue"
import UserJobList from "./components/UserJobList.vue"

const routes = [
    {
        name: "job-search",
        path: "/job_search/:id?",
        component: Search,
    },
    {
        name: "job-result",
        path: "/job_search/:slug/:id",
        component: DetailItem,
    },
    {
        name: "user-job-list",
        path: "/jobs_list/",
        component: UserJobList,
        meta: {
            requiresAuth: true
        }
    }
]

const router = createRouter({
    history: createWebHistory(
        '/',
    ),
    routes,
})


export default router
